import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { Reveal } from "./Reveal";
import { FAQS } from "./data";

export const Faq = () => {
  return (
    <section id="faq" className="bg-[#0B3D2E] py-24 md:py-36" data-testid="faq-section">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 grid lg:grid-cols-[1fr_1.5fr] gap-12 lg:gap-24">
        <div>
          <Reveal>
            <span className="eyebrow text-[#A6874E]">FAQ</span>
          </Reveal>
          <Reveal delay={0.1}>
            <h2
              className="mt-8 font-grotesk font-bold uppercase text-[#F2EDE1] leading-[0.98] tracking-tight text-4xl sm:text-5xl"
              data-testid="faq-heading"
            >
              Questions, <em className="font-display italic font-medium normal-case text-[#A6874E]">answered.</em>
            </h2>
          </Reveal>
          <Reveal delay={0.2}>
            <p className="mt-8 text-xs md:text-sm leading-relaxed text-[#F2EDE1]/55 max-w-xs">
              Pricing, process and timelines — the essentials before we start. Anything
              else, ask us through the form below.
            </p>
          </Reveal>
        </div>

        <Reveal delay={0.15}>
          <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
            {FAQS.map((f, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                className="border-b border-[#F2EDE1]/15"
                data-testid={`faq-item-${i}`}
              >
                <AccordionTrigger
                  className="text-left text-[#F2EDE1] hover:text-[#A6874E] hover:no-underline py-7 transition-colors duration-300"
                  data-testid={`faq-trigger-${i}`}
                >
                  <span className="flex items-baseline gap-6">
                    <span className="text-[10px] tracking-[0.25em] text-[#A6874E] font-medium shrink-0">
                      {String(i + 1).padStart(2, "0")}
                    </span>
                    <span className="text-base md:text-lg font-medium">{f.q}</span>
                  </span>
                </AccordionTrigger>
                <AccordionContent
                  className="text-xs md:text-sm leading-relaxed text-[#F2EDE1]/60 pb-7 pl-12 max-w-xl"
                  data-testid={`faq-content-${i}`}
                >
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
};
